import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SkeletonModule } from 'primeng/skeleton';
import { AvatarComponent } from './avatar.component';

@NgModule({
  imports: [CommonModule, SkeletonModule, AvatarComponent],
  exports: [AvatarComponent],
})
export class AvatarModule {}
